export default class FormatValue {
  constructor({ type, digits, mask }) {
    this.type = type;
    this.digits = digits;
    this.mask = mask;
  }

  /**
   * @param {unknown} obj
   * @return {FormatValue}
   */
  static fromJSON(obj) {
    if (!obj) return undefined;
    if (typeof obj !== 'object') throw new Error('not an object');
    return new FormatValue(obj);
  }
}
